export const adaptAddressSchema = (schema, isUserNRI = false) => {
  if (!Array.isArray(schema)) return schema;

  const reorderAddressFields = (fields, type) => {
    const labelField = fields.find((f) => f.name === `${type}AddressLabel`);

    const pincode = fields.find((f) => f.name === `pincode${type}`);
    const state = fields.find((f) => f.name === `state${type}`);
    const city = fields.find((f) => f.name === `city${type}`);
    const address = fields.find((f) => f.name === `address${type}`);

    // Modify pincode rules based on NRI
    if (pincode) {
      if (isUserNRI) {
        pincode.rules = ["mandatory"];
        pincode.enablePincodeLookup = false;
      } else {
        pincode.enablePincodeLookup = true;
      }

      pincode.relatedStateField = `state${type}`;
      pincode.relatedCityField = `city${type}`;
    }

    // Return new ordered fields
    return [
      ...(labelField ? [labelField] : []),
      ...(pincode ? [pincode] : []),
      ...(state ? [state] : []),
      ...(city ? [city] : []),
      ...(address ? [address] : []),
    ];
  };

  const transformedSchema = [];
  let i = 0;

  while (i < schema.length) {
    const field = schema[i];

    if (field.name === "residenceAddressLabel") {
      const residenceBlock = schema.slice(i, i + 5);
      transformedSchema.push(...reorderAddressFields(residenceBlock, "Residence"));
      i += 5;
      continue;
    }

    if (field.name === "workAddressLabel") {
      const workBlock = schema.slice(i, i + 5);
      transformedSchema.push(...reorderAddressFields(workBlock, "Work"));
      i += 5;
      continue;
    }

    transformedSchema.push(field);
    i++;
  }

  return transformedSchema;
};
